<div class="fuse-card auto-width p-t-0 p-l-20 p-r-15 m-b-10 acuation-card-border ">   
    <div fxLayout="row" fxLayoutAlign="space-between center">
        <div>
            <h3>{{sectionName}}</h3>
        </div>
        <div *ngIf="canDelete">
            <span  (click)="removeReportSection(this)"><mat-icon class="f-s-15">close</mat-icon></span>
        </div>
        <div *ngIf="!canDelete">
            <button mat-raised-button class="mat-accent" (click)="openAttributesPopup()">Añadir Atributo</button>
        </div>
    </div>

    <div fxLayout fxLayoutGap="20px" fxLayoutAlign="start">
        <div fxLayout="column" fxFlex.gt-sm="33" fxLayoutAlign="start" *ngFor="let reportColumn of this.reportList$">
            <mat-checkbox [checked]="report.checked" *ngFor="let report of reportColumn.column | listFilter: 'VISIBLE': true" (change)="setSelectedReport(report, $event)">{{report.text}}</mat-checkbox>
        </div>
    </div>

</div>


